import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerDashboardService {
  api_urls = {
    getCustomerDashBoardDetails : environment.URL+ "kreta/tenant/retrieve",
    getCustomerDetails: environment.URL+ "kreta/personalDetails/get",
    snoozePaymentBanner: environment.URL + "kreta/tenant/payment-banner/snooze"
  }

  constructor(private http: HttpClient) { }

  // No userId in the URL: the server resolves the tenant from the token, so a
  // customer can only ever snooze their own banner. Returns the recomputed
  // lifecycle, because the server clamps the deadline to three days before the
  // entitlement ends and the client should not have to guess what it did.
  snoozePaymentBanner(days: number = 3): Observable<any> {
    return this.http.post<any>(this.api_urls.snoozePaymentBanner, { days });
  }

  getTenantData(params: number|String): Observable<any> {
    const url = `${this.api_urls.getCustomerDashBoardDetails}/${params}`;
    return this.http.get<any>(url);
  }

  getPersonalDetails(params: number|String): Observable<any> {
    const url = `${this.api_urls.getCustomerDetails}/${params}`;
    return this.http.get<any>(url);
  }
}
